import {isFrame} from './isFrame';

export const isCrossOriginFrame = () => {
  try {
    return isFrame() && !window.top?.location.hostname;
  } catch (e) {
    return true;
  }
};
